import { useState } from "react";
import type { Question } from "@/domain/entities";
import { useLocale } from "../../i18n/LocaleProvider";
import { SubmitRow } from "./SubmitRow";
import styles from "./questions.module.css";

type NumberQuestion = Extract<Question, { type: "number" }>;

interface Props {
  question: NumberQuestion;
  value: number | undefined;
  optional: boolean;
  onSubmit: (value: number | undefined) => void;
}

export function NumberInput({ question, value, optional, onSubmit }: Props) {
  const { t, pick } = useLocale();
  const [text, setText] = useState(value !== undefined && !Number.isNaN(value) ? String(value) : "");
  const submit = () => onSubmit(text.trim() === "" ? Number.NaN : Number(text));
  return (
    <div className={styles.stack}>
      <input
        className={styles.field}
        type="number"
        inputMode="decimal"
        aria-label={pick(question.text)}
        placeholder={question.unit ? pick(question.unit) : t.questionnaire.numberPlaceholder}
        min={question.min}
        max={question.max}
        value={text}
        onChange={(e) => setText(e.target.value)}
      />
      <SubmitRow onNext={submit} onSkip={optional ? () => onSubmit(undefined) : undefined} />
    </div>
  );
}
